import Card from '../Card/Card';
import SectionTitle from '../SectionTitle/SectionTitle';

type CounterSize = 'medium' | 'large';
type CounterLayout = 'horizontal' | 'vertical';

type Props = {
    data: any[] | number;
    label: string;
    size?: CounterSize;
    layout?: CounterLayout;
}

const Counter = ({ data, label, size = 'medium', layout = 'horizontal' }: Props) => {
  const count = Array.isArray(data) ? data.length : data;

  return (
    <Card>
      <div className="relative h-full">
        <SectionTitle text={label} />
        <div className="flex justify-center items-center h-full">
          <p className={`${size === 'medium' ? 'text-7xl' : 'text-9xl'} font-bold`}>{count}</p>
        </div>
      </div>
    </Card>
  );
};

export default Counter;
